export default __webpack_public_path__ + "static/media/output-onlinegiftools (1).fd71873d.gif";